/* ════ BUILD ALL ═══════════════════════════════════════════ */
import { state } from '../state.js';
import { $ } from '../dom.js';
import { MO } from '../config.js';
import { addD } from '../utils/date.js';
import { buildHeader } from './header.js';
import { buildBody } from './body.js';

export function recalcDayW() {
  // Available timeline width = window minus the resource sidebar.
  const a = window.innerWidth - 148;
  // Fill the viewport: short views (e.g. 2w) get wider columns instead of
  // leaving whitespace; long views shrink down to a legible minimum.
  state.DAY_W = Math.max(20, Math.min(120, Math.floor(a / state.viewDays)));
  document.documentElement.style.setProperty('--day-w', state.DAY_W + 'px');
}

export function updatePeriodLbl() {
  const e = addD(state.viewStart, state.viewDays - 1); let lbl;
  if (state.viewDays >= 365) lbl = `${MO[state.viewStart.getMonth()]} ${state.viewStart.getFullYear()} – ${MO[e.getMonth()]} ${e.getFullYear()}`;
  else if (state.viewDays >= 84) lbl = `${MO[state.viewStart.getMonth()]} – ${MO[e.getMonth()]} ${e.getFullYear()}`;
  else lbl = `${MO[state.viewStart.getMonth()]} ${state.viewStart.getDate()} – ${MO[e.getMonth()]} ${e.getDate()}, ${e.getFullYear()}`;
  const pb = $('period-btn'); if (pb) pb.textContent = lbl;
}

export function buildGantt() { recalcDayW(); buildHeader(); buildBody(); updatePeriodLbl(); }
